import { UseCaseBasicType } from "@supportinitiative/common";
import Dashboard from "./Dashboard";
import { useMantineTheme } from "@mantine/core";

export function getDahsboards(
  entityId: string,
  useCaseId: string,
  runId: string,
  runSeq: string,
  access: string,
  dashboards: UseCaseBasicType["definition"]["dashboards"]
) {
  const theme = useMantineTheme();
  // This is needed this way for the react grid to work. The key should be the top most closure
  let displays = dashboards.map((dashboard) => {
    return (
      <div key={dashboard.id}>
        <Dashboard
          entityId={entityId}
          useCaseId={useCaseId}
          runId={runId}
          runSeq={runSeq}
          access={access}
          dashboard={dashboard}
        />
      </div>
    );
  });

  return displays;
}
